<template>
  <el-dialog :visible.sync="dialogVisible" v-loading="qrcodeLoading" :destroy-on-close="true" @close="onclose" title="手写签名" top="10vh"
    class="dp-dialog">
    <div class="signature-container">
      <div class="main-page">
        <div class="tip-text">
          请在下面的方框内签名（该签名会用在申请文件的签字区域，请规范签名）
        </div>
        <div class="canvas-wrapper">
          <canvas 
            ref="signatureCanvas" 
            class="signature-canvas"
            @mousedown="startDrawing"
            @mousemove="draw"
            @mouseup="stopDrawing"
            @mouseleave="stopDrawing"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="stopDrawing"
          ></canvas>
        </div>
        <div class="icon-group">
          <span @click="clearSignature"><i class="el-icon-refresh"></i>重新签名</span>
          <span @click="reuseSignature"><i class="el-icon-edit-outline"></i>复用签名</span>
        </div>
        <div class="button-group">
          <el-button type="primary" @click="submitSignature">提交</el-button>
          <el-button type="primary" @click="back">返回上一页</el-button>
          <!-- <el-button @click="clearSignature">重填签名</el-button> -->

          
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@api/api'
import axios from 'axios'
import { Empty } from 'vant'
export default {
  props: {
    detailInfo: {
      default: () => { return [] },
      type: Object,
      required: true
    },
    signType: {
      default: '',
      type: String,
      required: true
    },
    opera: {
      default: null,
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      checked: false,
      isShow: false,
      downNumber: 5, // 倒数字
      dialogVisible: false,
      qrcodeLoading: false,
      canvas: null,
      ctx: null,
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      currentApplicantIndex: 0,
      signatureName: '',
      drawingPaths: [], // 记录所有绘制路径
      currentPath: [] // 当前正在绘制的路径
    }
  },
  created () {

  },
  mounted() {
    
  },
  methods: {
    // 获取当前签名人的姓名与证件号（供签名坐标存取使用）
    getCurrentApplicant() {
      try {
        // 兼容不同来源的数据结构
        const list = (this.detailInfo && this.detailInfo.applicantInfoList) || this.applicantInfo || [JSON.parse(localStorage.getItem('applicantInfo'))]|| [];
        const idx = this.currentApplicantIndex || 0;
        const cur = list[idx] || {};
        const name = cur.applicantName || cur.name || cur.loginName || this.signatureName || '';
        const idNumber = cur.identificationCard || cur.idNumber || '';
        console.log(list, 'list');
        return { name, idNumber };
      } catch (e) {
        console.log(e);
        
        return { name: this.signatureName || '', idNumber: '' };
      }
    },
    open (searchType) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initCanvas();
      });
    },
    back () {
      this.onclose();
      this.$parent.gotoFaceId();
    },
    initCanvas() {
      this.canvas = this.$refs.signatureCanvas;
      if (!this.canvas) return;
      
      this.ctx = this.canvas.getContext('2d');
      
      // 设置 canvas 尺寸
      const wrapper = this.canvas.parentElement;
      this.canvas.width = wrapper.clientWidth;
      this.canvas.height = 180;
      
      // 绘制底层浅灰色文字
      this.drawBackgroundText();
    },
    drawBackgroundText() {
      if (!this.ctx) return;
      
      this.ctx.save();
      this.ctx.fillStyle = '#E0E0E0'; // 浅灰色
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'middle';
      
      // 获取当前申请人姓名
      let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'))
      let name = this.signatureName;
      console.log(applicantInfo);
      if (applicantInfo) {
        console.log();
        
        name = applicantInfo.loginName || this.signatureName;
      }
      
      // 将姓名转换为字符数组，去除空格
      const chars = name.replace(/\s+/g, '').split('');
      const charCount = chars.length;
      
      if (charCount === 0) {
        this.ctx.restore();
        return;
      }
      
      // 将canvas均匀分成几块
      const blockWidth = this.canvas.width / charCount;
      const blockHeight = this.canvas.height;
      
      // 根据字数动态调整系数：字数越少，系数越大
      // 2个字: 0.8, 3个字: 0.7, 4个字: 0.6, 5个字: 0.5, 6个字及以上: 0.5
      const sizeRatio = Math.max(1.0 - charCount * 0.1, 0.5);
      
      // 根据块的宽高取较小值来计算字体，确保字符不会超出块
      const fontSize = Math.floor(Math.min(blockWidth, blockHeight) * sizeRatio);
      this.ctx.font = `bold ${fontSize}px "Pingfang SC", "Microsoft YaHei", Arial, sans-serif`;
      
      // 绘制每个字符，每个字符在自己的块内居中
      chars.forEach((char, index) => {
        const blockCenterX = blockWidth * index + blockWidth / 2;
        const blockCenterY = blockHeight / 2;
        this.ctx.fillText(char, blockCenterX, blockCenterY);
      });
      
      this.ctx.restore();
    },
    getMousePos(e) {
      const rect = this.canvas.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    },
    getTouchPos(e) {
      const rect = this.canvas.getBoundingClientRect();
      return {
        x: e.touches[0].clientX - rect.left,
        y: e.touches[0].clientY - rect.top
      };
    },
    startDrawing(e) {
      this.isDrawing = true;
      const pos = this.getMousePos(e);
      this.lastX = pos.x;
      this.lastY = pos.y;
      // 开始新的路径
      this.currentPath = [{ x: pos.x, y: pos.y }];
    },
    draw(e) {
      if (!this.isDrawing) return;
      
      e.preventDefault();
      const pos = this.getMousePos(e);
      
      this.ctx.strokeStyle = '#000000'; // 黑色签名
      this.ctx.lineWidth = 3;
      this.ctx.lineCap = 'round';
      this.ctx.lineJoin = 'round';
      
      this.ctx.beginPath();
      this.ctx.moveTo(this.lastX, this.lastY);
      this.ctx.lineTo(pos.x, pos.y);
      this.ctx.stroke();
      
      // 记录路径点
      this.currentPath.push({ x: pos.x, y: pos.y });
      
      this.lastX = pos.x;
      this.lastY = pos.y;
    },
    stopDrawing() {
      if (this.isDrawing && this.currentPath && this.currentPath.length > 0) {
        // 保存当前路径
        this.drawingPaths.push([...this.currentPath]);
        this.currentPath = [];
      }
      this.isDrawing = false;
    },
    handleTouchStart(e) {
      e.preventDefault();
      this.isDrawing = true;
      const pos = this.getTouchPos(e);
      this.lastX = pos.x;
      this.lastY = pos.y;
      // 开始新的路径
      this.currentPath = [{ x: pos.x, y: pos.y }];
    },
    handleTouchMove(e) {
      if (!this.isDrawing) return;
      
      e.preventDefault();
      const pos = this.getTouchPos(e);
      
      this.ctx.strokeStyle = '#000000';
      this.ctx.lineWidth = 3;
      this.ctx.lineCap = 'round';
      this.ctx.lineJoin = 'round';
      
      this.ctx.beginPath();
      this.ctx.moveTo(this.lastX, this.lastY);
      this.ctx.lineTo(pos.x, pos.y);
      this.ctx.stroke();
      
      // 记录路径点
      this.currentPath.push({ x: pos.x, y: pos.y });
      
      this.lastX = pos.x;
      this.lastY = pos.y;
    },
    // 清空签名
    clearSignature() {
      if (!this.ctx || !this.canvas) return;
      
      // 清空整个 canvas
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      
      // 清空记录的路径
      this.drawingPaths = [];
      this.currentPath = [];
      
      // 重新绘制底层文字
      this.drawBackgroundText();
    },
    /**
     * 复用签名 - 从后端查询并绘制
     */
    async reuseSignature() {
      try {
        const { name, idNumber } = this.getCurrentApplicant();
        if (!name || !idNumber) {
          this.$message.warning('缺少姓名或证件号，无法查询签名');
          return;
        }
        const resp = await Api.getSignaturePaths({ name, idNumber });
        console.log(resp);
        const signaturePaths = (resp && resp.data && resp.data.data.coordinateInfo) ? JSON.parse(resp.data.data.coordinateInfo) : null;
        if (!signaturePaths || !Array.isArray(signaturePaths) || signaturePaths.length === 0) {
          this.$message.warning('暂无可复用的签名');
          return;
        }
        this.clearSignature();
        this.drawingPaths = signaturePaths;
        this.redrawSignature();
      } catch (error) {
        console.error('复用签名失败:', error);
        this.$message.error('复用签名失败，请重试');
      }
    },
    
    /**
     * 重新绘制签名到 canvas（带自动缩放和居中）
     */
    redrawSignature() {
      if (!this.ctx || !this.canvas || !this.drawingPaths.length) return;
      
      // 清空 canvas（保留背景文字）
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.drawBackgroundText();
      
      // 第一步：计算所有点的边界框
      let minX = Infinity;
      let maxX = -Infinity;
      let minY = Infinity;
      let maxY = -Infinity;
      
      this.drawingPaths.forEach(path => {
        path.forEach(point => {
          minX = Math.min(minX, point.x);
          maxX = Math.max(maxX, point.x);
          minY = Math.min(minY, point.y);
          maxY = Math.max(maxY, point.y);
        });
      });
      
      const signWidth = maxX - minX;
      const signHeight = maxY - minY;
      const signCenterX = minX + signWidth / 2;
      const signCenterY = minY + signHeight / 2;
      
      // 第二步：计算缩放比例（留10%边距）
      const targetWidth = this.canvas.width * 0.9;
      const targetHeight = this.canvas.height * 0.9;
      
      const scaleX = targetWidth / signWidth;
      const scaleY = targetHeight / signHeight;
      const scale = Math.min(scaleX, scaleY, 1.5); // 限制最大放大1.5倍
      
      // 第三步：计算画布中心
      const canvasCenterX = this.canvas.width / 2;
      const canvasCenterY = this.canvas.height / 2;
      
      // 设置签名样式
      this.ctx.strokeStyle = '#000000';
      this.ctx.lineWidth = 3;
      this.ctx.lineCap = 'round';
      this.ctx.lineJoin = 'round';
      
      // 第四步：应用缩放和居中后重绘所有路径
      this.drawingPaths.forEach(path => {
        if (path.length < 2) return;
        
        this.ctx.beginPath();
        
        // 第一个点
        let x = (path[0].x - signCenterX) * scale + canvasCenterX;
        let y = (path[0].y - signCenterY) * scale + canvasCenterY;
        this.ctx.moveTo(x, y);
        
        // 后续点
        for (let i = 1; i < path.length; i++) {
          x = (path[i].x - signCenterX) * scale + canvasCenterX;
          y = (path[i].y - signCenterY) * scale + canvasCenterY;
          this.ctx.lineTo(x, y);
        }
        
        this.ctx.stroke();
      });
    },
    
    // 提交签名
    async submitSignature() {
      if (!this.canvas) return;
      
      // 检查是否有签名内容
      if (this.drawingPaths.length === 0) {
        this.$message.warning('请先进行签名');
        return;
      }
      
      // 保存签名路径数据到后端（供复用）
      try {
        const { name, idNumber } = this.getCurrentApplicant();
        if (name && idNumber) {
          await Api.saveSignaturePaths({ name, idNumber, coordinateInfo: JSON.stringify(this.drawingPaths) });
        }
      } catch (error) {
        console.warn('签名坐标保存失败（不影响提交流程）:', error);
      }
      
      // 创建纯净的签名图片（不包含灰色底字）
      const pureSignatureData = this.createPureSignatureImage();
      
      // 上传签名到服务器
      try {
        this.qrcodeLoading = true;
        const uploadResult = await this.uploadSignature(pureSignatureData);
        // 如果还有下一位申请人
        if (this.detailInfo.applicantInfoList && this.currentApplicantIndex < this.detailInfo.applicantInfoList.length - 1) {
          this.currentApplicantIndex++;
          this.clearSignature();
          this.$message.success('当前签名已保存，请下一位申请人签名');
        } else {
          // 所有签名完成，生成文书
          this.$message.success('签名上传成功，正在生成申请书...');
          await this.generateDocument(uploadResult); // 生成撤回申请文书操作
        }
      } catch (error) {
        console.error('签名上传失败:', error);
        this.$message.error('签名上传失败，请重试');
      } finally {
        this.qrcodeLoading = false;
      }
    },
    
    /**
     * 生成带有签名的（申请、撤回、补正）文书
     */
    async generateDocument(uploadResult) {
      console.log('uploadResult', uploadResult);
      try {
        this.qrcodeLoading = true;
        
        
        if (this.signType === 'revoke') {
          // 构建请求参数（参考小程序的参数）
          const params = {
            signFileUrl: uploadResult.data.showPath,
            caseOrderNo: this.detailInfo.caseInfo.caseOrderNo,
            caseSource: 4, // 标识为签名后生成
            withdrawSource: +this.$route.query.searchType + 1
            // signFileId: uploadResult.id || uploadResult.evidenceId, // 签名文件ID
            // 如果是补正操作，需要添加 correction: 1
            // correction: 1
          };
          // 调用生成撤回文书接口，如果是申请、补正操作，需区分接口
          const response = await Api.WithdrawApplyExportWord(params);
          if (response.status === 200 && response.data) {
            // 关闭签名对话框
            this.dialogVisible = false;
            
            // 创建纯净的签名图片用于事件传递
            const pureSignatureData = this.createPureSignatureImage();
            
            // 触发事件，传递文书数据给父组件
            this.$emit('signature-submit', {
              signatureData: pureSignatureData,
              data: response.data
            });
          } else {
            throw new Error(response.message || '生成文书失败');
          }
        } else if (this.signType === 'onlineReview') {
          // 在线阅卷 - 调用生成文书接口
          const params = {
            sginUrl: uploadResult.data.showPath,
            caseOrderNo: this.detailInfo.caseInfo.caseOrderNo || this.detailInfo.caseOrderNo,
            applicantName: this.detailInfo.caseInfo.applicantName || ''
          };
          
          const response = await Api.sginConfirm(params);
          
          if (response.status === 200 && response.data && response.data.code == 0) {
            // 关闭签名对话框
            this.dialogVisible = false;
            
            // 触发事件，传递文书数据给父组件
            this.$emit('signature-submit', {
              data: response.data,
              signFileUrl: uploadResult.data.showPath
            });
          } else {
            throw new Error(response.data?.msg || response.message || '生成文书失败');
          }
        }  else if (this.signType === 'opinion') {
          this.dialogVisible = false;
          const pureSignatureData = this.createPureSignatureImage();
          this.$emit('signature-submit', {
            signatureData: pureSignatureData,
            uploadResult: uploadResult
          });
        } else {
          let params = {
            ...this.$parent.getSubmitData(),
            sign: 1,
          };
          if (this.opera != 0) {
            params.correction = 1;
          }
          const response = await Api.reconsiderApplyExportWord(params);
          if (response.status === 200 && response.data) {
            // 关闭签名对话框
            this.dialogVisible = false;
            // 创建纯净的签名图片用于事件传递
            const pureSignatureData = this.createPureSignatureImage();
            // 触发事件，传递文书数据给父组件
            this.$emit('signature-submit', {
              signatureData: pureSignatureData,
              data: response.data
            });
          } else {
            throw new Error(response.message || '生成文书失败');
          }
        }
      } catch (error) {
        console.error('生成文书失败:', error);
        this.$message.error(error.message || '操作失败，请重试');
      } finally {
        this.qrcodeLoading = false;
      }
    },
    
    /**
     * 将base64转换为Blob对象
     */
    base64ToBlob(base64Data) {
      const parts = base64Data.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);
      
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      
      return new Blob([uInt8Array], { type: contentType });
    },
    
    /**
     * 上传签名到服务器
     */
    async uploadSignature(base64Data) {
      // 将base64转换为Blob
      const blob = this.base64ToBlob(base64Data);
      
      // 获取申请人信息
      let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'));
      let fileName = '签名';
      if (applicantInfo && applicantInfo.loginName) {
        fileName = applicantInfo.loginName;
      }
      
      // 创建File对象
      const file = new File([blob], `${fileName}_${Date.now()}.png`, { type: 'image/png' });
      
      // 创建FormData
      const formData = new FormData();
      formData.append('file', file);
      
      // 获取案件编号（如果有）
      const caseOrderNo = localStorage.getItem('caseOrderNo') || this.$route.query.caseOrderNo || this.$route.query.number;
      if (caseOrderNo) {
        formData.append('caseOrderNo', caseOrderNo);
      }
      
      // kindType 6 表示签名文件（参考小程序的配置）
      formData.append('kindType', '6');
      
      // 申请阅卷和听取意见签名上传时传 isCheckAjbc:0，其余不传
      if (this.signType === 'onlineReview' || this.signType === 'opinion') {
        formData.append('isCheckAjbc  ', '0');
      }
      
      // 调用上传接口
      const response = await Api.appletsUpload(formData);
      console.log(response);
      
      
      if (response.status === 200 || response.success) {
        console.log('签名上传成功:', response);
        return response.data || response;
      } else {
        throw new Error(response.message || '上传失败');
      }
    },
    createPureSignatureImage() {
      // 创建一个新的canvas，只绘制用户的签名路径
      const pureCanvas = document.createElement('canvas');
      pureCanvas.width = this.canvas.width;
      pureCanvas.height = this.canvas.height;
      const pureCtx = pureCanvas.getContext('2d');
      
      // 设置白色背景
      pureCtx.fillStyle = '#FFFFFF';
      pureCtx.fillRect(0, 0, pureCanvas.width, pureCanvas.height);
      
      // 如果没有签名路径，直接返回空白图片
      if (!this.drawingPaths || this.drawingPaths.length === 0) {
        return pureCanvas.toDataURL('image/png');
      }
      
      // 第一步：计算所有点的边界框（与 redrawSignature 相同的逻辑）
      let minX = Infinity;
      let maxX = -Infinity;
      let minY = Infinity;
      let maxY = -Infinity;
      
      this.drawingPaths.forEach(path => {
        path.forEach(point => {
          minX = Math.min(minX, point.x);
          maxX = Math.max(maxX, point.x);
          minY = Math.min(minY, point.y);
          maxY = Math.max(maxY, point.y);
        });
      });
      
      const signWidth = maxX - minX;
      const signHeight = maxY - minY;
      const signCenterX = minX + signWidth / 2;
      const signCenterY = minY + signHeight / 2;
      
      // 第二步：计算缩放比例（留10%边距）
      const targetWidth = pureCanvas.width * 0.9;
      const targetHeight = pureCanvas.height * 0.9;
      
      const scaleX = targetWidth / signWidth;
      const scaleY = targetHeight / signHeight;
      const scale = Math.min(scaleX, scaleY, 1.5); // 限制最大放大1.5倍
      
      // 第三步：计算画布中心
      const canvasCenterX = pureCanvas.width / 2;
      const canvasCenterY = pureCanvas.height / 2;
      
      // 设置签名样式
      pureCtx.strokeStyle = '#000000';
      pureCtx.lineWidth = 3;
      pureCtx.lineCap = 'round';
      pureCtx.lineJoin = 'round';
      
      // 第四步：应用缩放和居中后重绘所有路径
      this.drawingPaths.forEach(path => {
        if (path.length < 2) return;
        
        pureCtx.beginPath();
        
        // 第一个点 - 应用缩放和居中变换
        let x = (path[0].x - signCenterX) * scale + canvasCenterX;
        let y = (path[0].y - signCenterY) * scale + canvasCenterY;
        pureCtx.moveTo(x, y);
        
        // 后续点 - 应用缩放和居中变换
        for (let i = 1; i < path.length; i++) {
          x = (path[i].x - signCenterX) * scale + canvasCenterX;
          y = (path[i].y - signCenterY) * scale + canvasCenterY;
          pureCtx.lineTo(x, y);
        }
        
        pureCtx.stroke();
      });
      
      return pureCanvas.toDataURL('image/png');
    },
    downloadSignature(base64Data) {
      // 获取申请人姓名用于文件名
      let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'));
      let name = '签名';
      if (applicantInfo && applicantInfo.loginName) {
        name = applicantInfo.loginName;
      }
      
      // 创建下载链接
      const link = document.createElement('a');
      link.href = base64Data;
      link.download = `${name}_${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    drawBackgroundTextToCanvas(ctx, canvas) {
      ctx.save();
      ctx.fillStyle = '#E0E0E0';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      // 获取当前申请人姓名
      let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'))
      let name = this.signatureName;
      if (applicantInfo) {
        name = applicantInfo.loginName || this.signatureName;
      }
      
      // 将姓名转换为字符数组，去除空格
      const chars = name.replace(/\s+/g, '').split('');
      const charCount = chars.length;
      
      if (charCount === 0) {
        ctx.restore();
        return;
      }
      
      // 将canvas均匀分成几块
      const blockWidth = canvas.width / charCount;
      const blockHeight = canvas.height;
      
      // 根据字数动态调整系数：字数越少，系数越大
      // 2个字: 0.8, 3个字: 0.7, 4个字: 0.6, 5个字: 0.5, 6个字及以上: 0.5
      const sizeRatio = Math.max(1.0 - charCount * 0.1, 0.5);
      
      // 根据块的宽高取较小值来计算字体，确保字符不会超出块
      const fontSize = Math.floor(Math.min(blockWidth, blockHeight) * sizeRatio);
      ctx.font = `bold ${fontSize}px "Pingfang SC", "Microsoft YaHei", Arial, sans-serif`;
      
      // 绘制每个字符，每个字符在自己的块内居中
      chars.forEach((char, index) => {
        const blockCenterX = blockWidth * index + blockWidth / 2;
        const blockCenterY = blockHeight / 2;
        ctx.fillText(char, blockCenterX, blockCenterY);
      });
      
      ctx.restore();
    },
    onclose () {
      this.dialogVisible = false;
      this.currentApplicantIndex = 0;
      this.drawingPaths = [];
      this.currentPath = [];
    },
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .dp-dialog {
    ::v-deep .el-dialog {
      width: 90% !important;
      max-width: 500px !important;

      .el-dialog__body {
        padding: 20px 15px;
      }
    }
  }
  
  .canvas-wrapper {
    width: 100% !important;
    
    .signature-canvas {
      width: 100% !important;
    }
  }
}

.dp-dialog {
  ::v-deep .el-dialog {
    width: 596px;

    .el-dialog__body {
      padding: 30px 40px;
    }
  }
}

.signature-container {
  .main-page {
    .tip-text {
      font-size: 14px;
      color: #666;
      margin-bottom: 20px;
      line-height: 1.6;
    }
    
    .canvas-wrapper {
      width: 100%;
      margin-bottom: 20px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      overflow: hidden;
      background-color: #ffffff;
      
      .signature-canvas {
        display: block;
        cursor: crosshair;
        touch-action: none;
        user-select: none;
      }
    }
    .icon-group {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 20px;
      span {
        cursor: pointer;
      }
    }
    
    .button-group {
      display: flex;
      justify-content: center;
      gap: 20px;
      
      .el-button {
        min-width: 120px;
      }
    }
  }
}
</style>
